export default __webpack_public_path__ + "static/media/flames.5f44fc01.jpg";